<section class="section-wrapper">
  <div class=""> <!--section-context-->
    <div class="f-col main-content">
      <!-- Table -->
      <div class="f-row filter-row custom-filter-container">
        <div class="sorting">
          <div class="filter-block">
            <button class="label-filter button-as-span" (click)="openFilter(filterModel)"> {{dynamicContent?.['b2b.manageapproval.filter']}} <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_down</mat-icon></button>
          </div>
          <mat-form-field class="selection-filter">
            <label class="mat-label" (click)="gtmSort()">{{dynamicContent?.['b2b.manageapproval.sortby']}}</label>
            <mat-select class="sort-flight-filter" [(value)]="selected" (click)="OnSortbyClick()">
              <mat-option value="Newest" (click)="applySorting('Newest')">{{dynamicContent?.['b2b.manageapproval.filterlist']?.[0]?.Phrase || 'Newest'}}</mat-option>
              <mat-option value="Oldest" (click)="applySorting('Oldest')">{{dynamicContent?.['b2b.manageapproval.filterlist']?.[1]?.Phrase || 'Oldest'}}</mat-option>
              <mat-option value="A-Z" (click)="applySorting('A-Z')">{{dynamicContent?.['b2b.manageapproval.filterlist']?.[2]?.Phrase || 'A-Z'}}</mat-option>
              <mat-option value="Z-A" (click)="applySorting('Z-A')">{{dynamicContent?.['b2b.manageapproval.filterlist']?.[3]?.Phrase || 'Z-A'}}</mat-option>

            </mat-select>
            <mat-icon fontSet="material-symbols-outlined" matSuffix (click)="gtmSort()"> swap_vert </mat-icon>
          </mat-form-field>
        </div>
      </div>
      <br>

      <div class="section-table data-listing cm-manageapprovals-listing">

        <table mat-table [dataSource]="tableData" class="mat-elevation-z0">
          <!-- Position Column -->
          <ng-container matColumnDef="Product">
            <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.manageapproval.product']}} </th>
            <td mat-cell *matCellDef="let element"> {{element.productName || '-'}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="Workflow Applied On">
            <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.manageapproval.workflowapplied']}} </th>
            <td mat-cell *matCellDef="let element" (click)="onRowClick(element)"> <span [matTooltip]="element.appliedForList" matTooltipPosition="below" class="tltp">{{element.workFlowType ==='Corporate-Branch'?'Corporate-Office location':element.workFlowType}}</span> </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="Created On">
            <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.manageapproval.createdon']}} </th>
            <td mat-cell *matCellDef="let element"> {{element.createdOn}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef> {{dynamicContent?.['b2b.manageapproval.actions']}} </th>
            <td mat-cell *matCellDef="let element" class="onclick-links">
              <a class="onclick-cell primary-link" tabindex="0" role="button" aria-label="edit item" (keydown.enter)="onEdit(element)" (click)="onEdit(element)">
                <mat-icon fontSet="material-symbols-outlined">edit</mat-icon>
              </a>
              <a class="onclick-cell warm-link" tabindex="0" role="button" aria-label="remove item" (keydown.enter)="onRemove(element)" (click)="onRemove(element)">
                <mat-icon fontSet="material-symbols-outlined">delete</mat-icon>
              </a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>

      <div class="f-row more-action justify-center" [style.marginTop.px]="10" *ngIf="totalPages > 1">
        <button class="button--prev" (click)="prevPage()" [class.disabled]="currentPage === 0"> 
          <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_left</mat-icon>  
        </button>
        <button mat-button class="button--secondary-small">{{ currentPage + 1 }}</button>
        <button class="button--next" (click)="nextPage()" [class.disabled]="(currentPage + 1) >= totalPages">
          <mat-icon class="material-symbols-outlined me-0">keyboard_arrow_right</mat-icon>  
        </button>
      </div>

      <div class="inner-action action-listing">
        <button mat-button class="button--primary-small" (click)="AddnewApproval()">{{dynamicContent?.['b2b.manageapproval.Add']}}</button>
      </div>

      <ng-template #selectionWarning>
        <div class="custom-dialog">
          <div class="d-justify-bw">
            <div class="custom-dialog__left">
              <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                <h2 class="mat-dialog-title"> {{dynamicContent?.['b2b.manageapproval.confirmchanges'] || 'Confirm changes'}}</h2>
                <!-- <div class="custom-overlay-close">
                  <mat-icon fontSet="material-symbols-outlined" class="close_icon" (click)="CloseDialog(false)">close</mat-icon>
                </div> -->
              </div>
              <mat-dialog-content class="custom-dialog__text">
                <div class="custom-dialog__description">{{dynamicContent?.['b2b.manageapproval.wantremoveapprovalmanage'] || 'Are you sure you want to remove this approval management?'}}</div>
              </mat-dialog-content>
              <mat-dialog-actions>
                <div class="dialog-actions-right">
                  <button class="button--secondary-small" mat-button (click)="CloseDialog(false)">{{dynamicContent?.['b2b.manageapproval.cancel'] || 'Cancel'}}</button>
                  <button class="button--primary-small" mat-button (click)="CloseDialog(true)">{{dynamicContent?.['b2b.manageapproval.confirm'] || 'Confirm'}}</button>
                </div>
              </mat-dialog-actions>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="section-table data-listing" *ngIf="!IsShow || tableData.length<=0">
        <app-cam-empty-state [heading]="heading" [content]="content" [IsShow]="IsShow" [navigateTo]="'workflow-setting'"></app-cam-empty-state>
      </div>

    </div>
  </div>
</section>
<ng-template #filterModel>
  <div class="custom-popup-gen-container">
    <div class="custom-popup-gen-header">
      <span>{{dynamicContent?.['b2b.manageapproval.filters']}}</span>
      <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button" aria-label="close button" (keyup.space)="filterModalRef.close()" (keydown.enter)="filterModalRef.close()" (click)="filterModalRef.close()">close</mat-icon>
    </div>
    <div class="custom-popup-gen-body">

      <p class="custom-popup-gen-heading">{{dynamicContent?.['b2b.manageapproval.workflowapplied']}}</p>
      <div class="custom-popup-filter">
        <mat-checkbox class="checkbox-wrapper" [checked]="isChecked(workApplied.id)" *ngFor=" let workApplied of commonObjPipes.GetAllRuleAppliedOnData.pipe" (change)="filterAppliedOn($event, workApplied.id)">{{workApplied.name ==='Corporate-Branch'?'Corporate-Office location':workApplied.name}}</mat-checkbox>
      </div>
    </div>
    <div class="custom-popup-gen-footer">
      <button
        class="button--primary-small"
        mat-button
        (click)="sendWorkAppliedID()">
        {{dynamicContent?.['b2b.manageapproval.apply']}}
      </button>
      <!-- [disabled]="isApplyDisabled"
      [ngClass]="{ 'button--disabled': isApplyDisabled }" -->
    </div>
  </div>
</ng-template>